import { Masked, PrimaryCTA, GhostCTA, Crosshair, Eyebrow } from "./bits";

const CTASection = ({
    heading = ["Your Next Profit Opportunity", "May Already Be", "Inside Your Business."],
    sub = "Find out where revenue is leaking, where costs may be reduced, and where the highest-value opportunities exist.",
    primary = "Request Your Business X-Ray",
    secondary = "Book an Executive Review",
    testid = "final-cta",
}) => (
    <section className="relative overflow-hidden bg-ink text-ivory" data-testid={testid}>
        <div className="bg-grid-dark absolute inset-0" aria-hidden="true" />
        <div className="absolute left-1/2 top-0 h-px w-2/3 -translate-x-1/2 bg-gradient-to-r from-transparent via-vantera/60 to-transparent" aria-hidden="true" />
        <Crosshair pos="top-6 left-6" dark />
        <Crosshair pos="top-6 right-6" dark />
        <Crosshair pos="bottom-6 left-6" dark />
        <Crosshair pos="bottom-6 right-6" dark />

        <div className="container-x relative py-28 sm:py-36">
            <Eyebrow dark>The next move</Eyebrow>
            <Masked
                lines={heading}
                as="h2"
                inview
                className="mt-8 max-w-5xl font-display text-4xl font-extrabold leading-[1.05] tracking-tightest sm:text-6xl lg:text-7xl"
            />
            <p className="mt-8 max-w-2xl text-lg leading-relaxed text-cloud sm:text-xl">{sub}</p>
            <div className="mt-12 flex flex-col gap-4 sm:flex-row sm:items-center">
                <PrimaryCTA to="/contact" dark testid={`${testid}-primary`}>{primary}</PrimaryCTA>
                <GhostCTA to="/contact" dark testid={`${testid}-secondary`}>{secondary}</GhostCTA>
            </div>
        </div>
    </section>
);

export default CTASection;